import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Box,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Course } from "../../model/entity/Course";
import { KeyboardArrowUp, ThumbDown, ThumbUp } from "@mui/icons-material";
import { OverviewFilterField } from "../../components/OverviewFilterField";
import handleAxiosError from "../../components/ErrorHandler";
import { notifErr, notifWarn } from "../../components/Functions";
import { TrainingSchedule } from "../../model/entity/TrainingSchedule";
import { getFetcher } from "../../components/Fetchers";
import dayjs from "dayjs";

function Row({ course, filter }: { course: Course; filter: string }) {
  return (
    <React.Fragment>
      <TableRow key={course.id} className={"collapsibleTableRow"}>
        <TableCell className="tableCell tableFirstCell" width={"28%"}>
          {course.name}
          <IconButton size="small" disabled sx={{ opacity: 0 }}>
            <KeyboardArrowUp />
          </IconButton>
        </TableCell>
        <TableCell className="tableCell">
          {course.coachLeadsCourses.map((clc) => clc.coach.nickname).join(", ")}
        </TableCell>
      </TableRow>
      {course.memberInCourses.length > 0 && (
        <TableRow>
          <TableCell sx={{ borderBottom: "none" }} colSpan={1}>
            <Collapse in={true} timeout="auto" unmountOnExit>
              <Box sx={{ marginTop: "0.5rem", marginBottom: "1.5rem" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", border: "none" }}>
                        Jméno
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: "bold", border: "none" }}
                      >
                        Zaplatil
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {course.memberInCourses.map(
                      (mic) =>
                        (mic.member.firstName + " " + mic.member.lastName)
                          .toLowerCase()
                          .includes(filter.toLowerCase()) && (
                          <TableRow
                            key={mic.id}
                            sx={{
                              border: "1px solid #e0e0e0",
                            }}
                          >
                            <TableCell>
                              {mic.member.firstName + " " + mic.member.lastName}
                            </TableCell>
                            <TableCell align="right">
                              {mic.paid ? (
                                <ThumbUp
                                  className="thumbUp"
                                  sx={{ marginRight: "0.75rem" }}
                                />
                              ) : (
                                <ThumbDown
                                  className="thumbDown"
                                  sx={{ marginRight: "0.75rem" }}
                                />
                              )}
                            </TableCell>
                          </TableRow>
                        )
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
}

const CoursesOverview = () => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [trainingSchedule, setTrainingSchedule] =
    useState<TrainingSchedule | null>(null);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrainingSchedule = async () => {
      try {
        const response = await getFetcher(
          `${process.env.REACT_APP_API_URL}/schedules/active`
        );
        setTrainingSchedule(response.data);
      } catch (err) {
        notifErr(handleAxiosError(err));
      }
      setLoading(false);
    };
    fetchTrainingSchedule();
  }, []);

  useEffect(() => {
    if (!loading && trainingSchedule === null) {
      notifWarn(
        "Nebyl nalezen žádný tréninkový rozvrh. Pro přidání" +
          " nebo úpravu kurzů vytvořte nový rozvrh v sekci\n" +
          "Tréninkový rozvrh - Nastavení.",
        null
      );
    }
  }, [loading, trainingSchedule]);

  useEffect(() => {
    const fetchCourses = async () => {
      const config = {
        day: dayjs().format("dddd").toUpperCase(),
      };
      try {
        const response = await getFetcher(
          `${process.env.REACT_APP_API_URL}/courses/all-active-by-day`,
          config
        );
        setCourses(response.data);
      } catch (err) {
        notifErr(handleAxiosError(err));
      }
    };

    fetchCourses();
  }, []);

  return (
    <div className="tableContainer">
      <div className="aboveTableWrapper" style={{ justifyContent: "right" }}>
        <OverviewFilterField
          setFilter={setFilter}
          label={"Najít člena..."}
          disabled={trainingSchedule === null}
        />
      </div>
      <Paper
        className="tableContainer"
        elevation={courses.length ? 1 : 0}
        sx={{ width: "70%", maxHeight: "48rem" }}
      >
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow className="tableHeader">
                <TableCell className="tableHeaderCell tableHeaderFirstCell">
                  Název kurzu
                </TableCell>
                <TableCell className="tableHeaderCell">Trenéři</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {courses
                .filter((c) =>
                  c.memberInCourses.some((mic) =>
                    (mic.member.firstName + " " + mic.member.lastName)
                      .toLowerCase()
                      .includes(filter.toLowerCase())
                  )
                )
                .map((course) => (
                  <Row key={course.id} course={course} filter={filter} />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default CoursesOverview;
